import { useEffect, useState } from "react";
import AppLayout from "../components/common/AppLayout";
import ProfileCard from "../components/profile/ProfileCard";
import ProfileForm from "../components/profile/ProfileForm";
import { getMyProfileApi, updateMyProfileApi } from "../api/profileApi";
import useAuth from "../hooks/useAuth";

export default function MiPerfilPage() {
    const { user, login } = useAuth();

    const [profile, setProfile] = useState(null);
    const [loadingPage, setLoadingPage] = useState(true);
    const [loadingSave, setLoadingSave] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");

    const loadProfile = async () => {
        setLoadingPage(true);
        setError("");

        try {
            const data = await getMyProfileApi();
            setProfile(data.user);
        } catch (err) {
            setError(err.message || "No se pudo cargar el perfil");
        } finally {
            setLoadingPage(false);
        }
    };

    useEffect(() => {
        loadProfile();
    }, []);

    const handleUpdate = async (form) => {
        setLoadingSave(true);
        setError("");
        setSuccess("");

        try {
            const resp = await updateMyProfileApi(form);
            setProfile(resp.user);
            setSuccess("Perfil actualizado correctamente");

            if (login) {
                const token = localStorage.getItem("token");
                login({
                    token,
                    user: resp.user,
                });
            }
        } catch (err) {
            setError(err.message || "No se pudo actualizar el perfil");
        } finally {
            setLoadingSave(false);
        }
    };

    return (
        <AppLayout title="Mi perfil">
            <div className="page-section">
                {loadingPage ? (
                    <p>Cargando perfil...</p>
                ) : (
                    <>
                        <ProfileCard user={profile || user} />

                        <div style={{ height: "16px" }} />

                        {error && <p className="auth-error">{error}</p>}
                        {success && <p style={{ color: "#16a34a", marginBottom: "12px" }}>{success}</p>}

                        <ProfileForm
                            initialData={profile || user}
                            onSubmit={handleUpdate}
                            loading={loadingSave}
                        />
                    </>
                )}
            </div>
        </AppLayout>
    );
}